import { CaseSettings } from '../domain/case/CaseDomains';
import RoleHelper from '../RoleHelper';

export type CaseActionMenu = 'Cases' | 'ACH';

export function canUseCaseGo(caseSettings: CaseSettings | undefined | null, menu: CaseActionMenu = 'Cases'): boolean {
  return canEditCaseDomain(caseSettings, menu);
}

export function canEditCaseDomain(caseSettings: CaseSettings | undefined | null, menu: CaseActionMenu = 'Cases'): boolean {
  if (caseSettings == undefined || caseSettings == null) {
    return false;
  }
  RoleHelper.setCurrentAccess(caseSettings);
  const canEdit: boolean = RoleHelper.canEdit(menu);
  RoleHelper.clearCurrentAccess();
  return canEdit;
}

export function hasExplicitAllowAssignUsers(caseSettings: Pick<CaseSettings, 'allowAssignUsers'> | undefined | null): boolean {
  return Array.isArray(caseSettings?.allowAssignUsers);
}

export function isAllowAssignUserListed(username: string, caseSettings: Pick<CaseSettings, 'allowAssignUsers'> | undefined | null): boolean {
  if (!hasExplicitAllowAssignUsers(caseSettings)) {
    return false;
  }
  return (caseSettings?.allowAssignUsers ?? []).includes(username);
}
